
export const modeColorChanger = (colorId) => {
    if (!colorId) return null;
    localStorage.setItem('data-color-mode', colorId);
    document
        .body.parentNode
        .setAttribute('data-color-mode', colorId);
}

export const modeColorGetter = ({isStrong} = {}) => {
    const theme = localStorage.getItem('data-color-mode');
    if (isStrong) return theme;
    return theme || "dark";
}